import React, { Component } from 'react'

import Giphy from './giphy'

import ChatMentionInput from 'components/input/chat-mention-input'
import Picker from 'emoji-picker-react'

import GifIcon from 'images/icons/gif.jsx'

import Button from 'components/button/button'

import { debounce } from 'lodash'

import {
	isMobile,
	getFileFromCamera,
	doDirtyInput,
	doClickEventListeners
} from 'utils'

// Quill reports an empty document as one of these; treat them as no content.
const EMPTY_QUILL_VALUES = ['', '<p></p>', '<p><br></p>']

const isEmptyValue = value => (
	!value || EMPTY_QUILL_VALUES.indexOf(value) !== -1
)

import isEqual from 'react-fast-compare'

export default class DockChatInput extends Component {
	state = {
		inputValue: ''
	}

	constructor(props) {
		super(props)

		this.debouncedSetTyping = debounce(this.handleDebouncedSetTyping, 300)
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		const isAllEqual = isEqual(this.props, nextProps) && isEqual(this.state, nextState)

		return !isAllEqual
	}

	componentDidUpdate = _ => {
		window.requestAnimationFrame(_ => {
			if (this.inputContainer) {
				const newChatHeight = this.inputContainer.getBoundingClientRect().height
				const oldChatHeight = this.props.inputsHeight

				if (newChatHeight !== oldChatHeight) {
					this.props.updateInputsHeight(newChatHeight)
				}
			}
		})
	}

	handleClickOutside = e => {
		const {
			openCallout,
			toggleEmojis,
			toggleGiphy
		} = this.props

		if (!openCallout) {
			return
		}

		const refElement = this[openCallout + 'Ref']

		if (!refElement) {
			return
		}

		if (!e || !refElement.contains(e.target)) {
			if (openCallout === 'emoji') {
				toggleEmojis()
			} else {
				toggleGiphy()
			}
		}
	}

	componentDidMount = _ => {
		doClickEventListeners(this.handleClickOutside)
	}

	componentWillUnmount() {
		const {
			chatObject
		} = this.props

		doDirtyInput('remove', 'chat-' + chatObject.id)
		doClickEventListeners(this.handleClickOutside, true)
	}

	handleChange = value => {
		const {
			chatObject
		} = this.props

		this.debouncedSetTyping()

		doDirtyInput(isEmptyValue(value) ? 'remove' : 'add', 'chat-' + chatObject.id)

		this.setState({
			inputValue: value
		})
	}

	// The Quill HTML the parent should actually send ('' when empty).
	getValue = _ => (
		isEmptyValue(this.state.inputValue) ? '' : this.state.inputValue
	)

	focusInput = _ => {
		if (this.chatInput) {
			this.chatInput.focus()
		}
	}

	handleDebouncedSetTyping = () => {
		const {
			setTyping
		} = this.props

		setTyping(!isEmptyValue(this.state.inputValue))
	}

	selectEmoji = (event, emojiObject) => {
		this.props.toggleEmojis()

		if (this.chatInput) {
			this.chatInput.insertText(emojiObject.emoji)
		}
	}

	selectGiphy = (giphyObject) => {
		this.props.toggleGiphy()

		if (this.chatInput) {
			this.chatInput.insertImage(giphyObject.images.downsized.url)
		}

		setTimeout(_ => {
			this.sendMessage()
		})
	}

	sendMessage = _ => {
		this.props.sendMessage()

		setTimeout(_ => {
			this.setState({
				inputValue: ''
			})
		})
	}

	render() {
		const {
			handleFocusChange,
			chatObject,
			uploadFile,
			openCallout,
			optimistic,
			isTeamChat,
			toggleEmojis,
			toggleGiphy,
			userData,
			hasMounted,
			isBigChat,
			availableMentions,
		} = this.props

		const {
			inputValue
		} = this.state

		return (
			<div className="input-container" ref={ref => this.inputContainer = ref}>
				<ChatMentionInput
					ref={ref => { this.chatInput = ref }}
					disabled={(optimistic || (chatObject.userIds && chatObject.userIds.length < 2)) && !isTeamChat}
					availableMentions={availableMentions}
					value={inputValue}
					onChange={this.handleChange}
					onEnter={this.sendMessage}
					onKeyDown={_ => handleFocusChange(true)}
					onFocus={_ => {
						handleFocusChange(true)
					}}
					onBlur={_ => {
						handleFocusChange(false)
					}}
					placeholder="Write your message here."
				/>
				<div className="chat-inputs">
					<div className="input-buttons" ref={ref => { this.buttonContainerRef = ref }}>
						{
							!isMobile() ?
								<Button icon="smile-o" callback={toggleEmojis} />
								:
								<Button icon="camera" callback={_ => {
									getFileFromCamera(uploadFile, userData)
								}} />
						}
						<Button
							callback={toggleGiphy}
							svgIcon={GifIcon}
						/>
						<Button
							callback={uploadFile}
							icon={'paperclip'}
							hasFile={true}
						/>
					</div>
					{hasMounted ?
						<React.Fragment>
							{!isMobile() ?
								<div
									ref={ref => { this.emojiRef = ref }}
									className={`emojis-popup ${openCallout === 'emoji' ? 'visible' : ''}`}
								>
									<Picker
										onEmojiClick={this.selectEmoji}
										disableAutoFocus={true}
										native
									/>
								</div>
								:
								null}
							<div
								ref={ref => { this.giphyRef = ref }}
								className={`giphy-popup ${openCallout === 'giphy' ? 'visible' : ''}`}
							>
								<Giphy
									selectGiphy={this.selectGiphy}
									isBigChat={isBigChat}
									openCallout={openCallout}
								/>
							</div>
						</React.Fragment>
						: null}
					<button
						disabled={isEmptyValue(inputValue)}
						onClick={this.sendMessage}
						className="send-button"
					>
						Send
					</button>
				</div>
			</div>
		)
	}
}
